/**
 * Future Funding is the DEPENDENT of the other two commitment figures: Total
 * less Initial, never negative (Edward, 4 Nov 2026). One definition for the
 * browser readers, mirroring backend `app.underwriting.dealfields`
 * (`PLACEHOLDER_AMOUNT_USD`, `SHEET_ROUNDING_USD`, `_future_funding`,
 * `settled_future_funding`); a backend test pins the numbers together.
 */

/** The $1 Backshop keys where an amount is "not entered": a total at or below it is no commitment. */
export const PLACEHOLDER_AMOUNT_USD = 1

/** How far a stated Future Funding may sit from Total less Initial and still be the sheet's own
 *  rounding (the Pipeline sheet prints $ millions to four decimals): the same $100 the importer reads. */
export const SHEET_ROUNDING_USD = 100

/** Total less Initial, clamped at zero. NaN — nothing to derive — for a placeholder total. */
export function futureFundingOf(total: number, initial: number): number {
  if (total <= PLACEHOLDER_AMOUNT_USD) return Number.NaN
  return Math.max(total - initial, 0)
}

/**
 * The Future Funding a reader shows: Total less Initial where both are RECORDED figures, else the
 * figure as stated. A stated figure within the sheet's rounding of the derived one stands.
 */
export function settledFutureFunding(
  total: number | null,
  initial: number | null,
  stated: number | null,
): number | null {
  if (total != null && initial != null && total > PLACEHOLDER_AMOUNT_USD) {
    const derived = Math.max(total - initial, 0)
    if (stated == null || Math.abs(stated - derived) > SHEET_ROUNDING_USD) return derived
  }
  return stated
}
